import { LazyLoad } from 'app/utils';

export const PreAgentListPage = LazyLoad(
  () => import('./index'),
  (module) => module.PreAgentListPage,
);
